import sendRequest from "../../../helpers/requestHelper";
import config from "../../../config";
import eventBus from "../../../event-bus/eventBus";
import {handleError} from "../../../helpers/handleError";

const openDocument = {
    namespaced: true,
    mutations: {
        OPEN_FILE_SUCCESS(state, response) {
            eventBus.$emit("openDocumentSuccess", response);
        },
        OPEN_FILE_FAILURE(state, error) {
            let dataReceive = {
                title: error.response.data.message,
                message: handleError(error) !== "" ? handleError(error) : error.response.data.data.message
            }
            eventBus.$emit("operationFailure", dataReceive);
        }
    },
    actions: {
        openFile: function({ dispatch }, payload) {
            var promise = sendRequest("get", config.baseURLApi + "/documents/" + payload.creds.item.id + "/open");
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successOpenFile", { result: result[1], item: payload.creds.item });
                } else {
                    dispatch("failureOpenFile", result[1]);
                }
            })
        },
        successOpenFile: function({ commit }, response) {
            commit("OPEN_FILE_SUCCESS", response);
        },
        failureOpenFile: function({ commit }, error) {
            commit("OPEN_FILE_FAILURE", error);
        }
    }
}

export default openDocument;